import i18n from 'helpers/i18n';
import messages from './messages';

export function PrimaryAdminHierarchyDisplay({ name }: { name?: string }) {
  return (
    <div className="flex flex-col gap-1 font-sans">
      <label className="font-semibold text-base text-black">
        {i18n.ft(messages.hierarchyAssocLabel)}
      </label>
      <div
        tabIndex={0}
        className={
          'relative text-base text-[#3C3F42] border border-[#889EBB] rounded-lg p-2 text-navy-200 cursor-not-allowed'
        }
      >
        <div className="flex flex-wrap gap-1.5">
          <span className="inline-flex items-center px-2 py-1 rounded text-[#3C3F42] text-sm font-medium">
            {name}
          </span>
        </div>
      </div>
      <div className="font-semibold text-sm text-gray-600 m-0 px-1 flex items-center gap-1">
        <i className="fa-solid fa-circle-info" aria-hidden="true" />
        {i18n.ft(messages.primaryAdminHierarchyInfo)}
      </div>
    </div>
  );
}
